import { ModuleWithProviders, NgModule } from '@angular/core';
import { DevicesServiceWithCache } from './devices-cache.service';

@NgModule()
export class DeviceSummariesServiceWithCacheModule {
  static forRoot(): ModuleWithProviders<DeviceSummariesServiceWithCacheModule> {
    return {
      ngModule: DeviceSummariesServiceWithCacheModule,
      providers: [DevicesServiceWithCache]
    };
  }
}
